/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { StationPagedList } from '../../models/station-paged-list';

export interface PersonalSearchStation$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the station's name
 *   * ENERGY : the station's energy
 *   * CITY : the station's city
 *   * STATE : the station's state
 *   * NETWORK : the station's network
 *   * CODE : the station's code
 *   * SERVICE : the station's service
 *   * ACCESS : the station's access
 *   * VISIBILITY : the station's visibility
 */
  sortFieldName?: 'NAME' | 'ENERGY' | 'CITY' | 'STATE' | 'NETWORK' | 'CODE' | 'SERVICE' | 'ACCESS' | 'VISIBILITY';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search station
     */
    body?: any
}

export function personalSearchStation$Any(http: HttpClient, rootUrl: string, params?: PersonalSearchStation$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPagedList>> {
  const rb = new RequestBuilder(rootUrl, personalSearchStation$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationPagedList>;
    })
  );
}

personalSearchStation$Any.PATH = '/personalspace/station/search';
